module.exports = __webpack_public_path__ + "assets/3-Raleigh-Tech-Sales-Management.b08f8c7e.png";